import { Component, Input } from "@angular/core";
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: "access-denied-card",
    standalone: true,
    imports: [MatCardModule],
    templateUrl: './access-denied-card.component.html',
    styleUrls: ['./access-denied-card.component.less']
})
export class AccessDeniedCardComponent {
    @Input() title: string = 'Access Restricted';
    @Input() tabName: string = '';
    @Input() roleCode: string = '';
    @Input() roleDescription: string = '';
}
